export default async function () {
  const algoKeyGen = {
    name: "AES-GCM",
    length: 256,
  };
  const key = await window.crypto.subtle.generateKey(algoKeyGen, true, ["encrypt"]);
  const keyExport = await window.crypto.subtle.exportKey("jwk", key);
  return keyExport.k?.substring(0, 16);
}
